/**
 * Truncates the middle part of a string if it's longer than a specified length.
 *
 * This function checks if the input string exceeds a length of 12 characters.
 * If it does, the function truncates the string by keeping the first 5 characters,
 * then appending three ellipses (...), and finally, adding the last 6 characters of the string.
 * If the string is 12 characters or shorter, it returns the original string.
 */
export function truncateMiddleOfString(s: string): string {
    if (s.length > 12) {
        return `${s.substring(0, 5)}...${s.substring(s.length - 6)}`;
    }
    return s;
}
